import React from "react";
import CommonModal from "../commonmodal/CommonModal";
import { primaryColor } from "../../../utils/comon";

const AttendanceActivityModal = ({ isOpen, onClose, selectedRecord, isLiveFetching }) => {
    return (
        <CommonModal
            isOpen={isOpen}
            onClose={onClose}
            title="Activity Log Details"
            subTitle={`Daily punching timeline for ${selectedRecord?.employeeName || ""} on ${selectedRecord?.date || ""}`}
        >
            {selectedRecord && (
                <div className="space-y-6 pt-2 max-h-[60vh] overflow-y-auto pr-2 scrollbar-hide">
                    <div className="space-y-4 relative min-h-[50px]">
                        {isLiveFetching && (
                            <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 rounded-lg">
                                <div className="w-5 h-5 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
                            </div>
                        )}

                        {selectedRecord.punchHistory?.length > 0 ? (
                            <div className="max-h-44 overflow-y-auto pr-2 border border-slate-100 rounded-lg p-3 bg-[#F8FAFC]">
                                <div className="border-l-2 border-slate-200 pl-4 space-y-4 ml-2 pt-1 pb-1">
                                    {selectedRecord.punchHistory.map((punch, idx) => (
                                        <div key={idx} className="relative flex flex-col gap-0.5 text-xs">
                                            <div
                                                className="absolute -left-[23px] top-1 w-2.5 h-2.5 rounded-full border-2 border-white shadow-sm"
                                                style={{ backgroundColor: (punch.type === "Entry" || punch.type.includes("In")) ? primaryColor() : "#EF4444" }}
                                            />
                                            <div className="flex items-center gap-2 justify-between">
                                                <strong className="text-slate-800">{punch.type}</strong>
                                                <span className="text-[10px] font-bold text-gray-500 bg-white px-2 py-0.5 rounded shadow-sm border border-slate-100">{punch.time}</span>
                                            </div>
                                            <span className="text-[10px] font-semibold text-slate-500">{punch.device}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div className="flex flex-col items-center justify-center py-6 text-gray-400 bg-[#F8FAFC] rounded-lg border border-slate-100">
                                <span className="font-bold text-xs">No punch records found</span>
                                <span className="text-[10px]">Employee might be absent or missing punches</span>
                            </div>
                        )}
                    </div>

                    <div className="flex justify-end pt-4 border-t border-gray-100">
                        <button
                            onClick={onClose}
                            className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-700 bg-transparent hover:bg-slate-50 transition-colors text-xs font-bold"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </CommonModal>
    );
};

export default AttendanceActivityModal;
